import Scorecard from '@/app/scorecard'
import { ability } from '@/casl/ability'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import { createFileRoute, redirect } from '@tanstack/react-router'

const RouteComponent = () => {
  const search = Route.useSearch()
  return <Scorecard initialSearch={search} />
}

export const Route = createFileRoute('/_auth/_withProject/scorecard')({
  validateSearch: (search: Record<string, unknown>) => ({
    date: search.date ? String(search.date) : undefined,
  }),
  beforeLoad: ({ context }) => {
    if (ability && context.auth.user && !ability.can('read', 'Puantaj')) {
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  component: RouteComponent,
})


